export const apiConstants = {
  reset: "/api/password/reset",
  forgot: "/api/password/forgot"
};
